import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface FileGroup {
  id: string;
  interaction_id: string;
  name: string;
  text_color: string;
  bg_color: string;
  archive_ids: string[];
  created_at?: string;
  updated_at?: string;
}

export interface CreateFileGroupRequest {
  name: string;
  text_color: string;
  bg_color: string;
  archive_ids?: (string | number)[];
}

export interface UpdateFileGroupRequest {
  name: string;
  text_color: string;
  bg_color: string;
}

@Injectable({ providedIn: 'root' })
export class FileGroupsService {
  private baseUrl = '/api/interactions/';

  constructor(private http: HttpClient) {}

  list(interactionId: number | string): Observable<FileGroup[]> {
    return this.http.get<{ message: string; file_groups: FileGroup[] }>(`${this.baseUrl}${interactionId}/file-groups`)
      .pipe(map(response => response.file_groups || []));
  }

  create(interactionId: number | string, data: CreateFileGroupRequest): Observable<FileGroup> {
    return this.http.post<{ message: string; file_group: FileGroup }>(`${this.baseUrl}${interactionId}/file-groups`, data)
      .pipe(map(response => response.file_group));
  }

  update(interactionId: number | string, groupId: string, data: UpdateFileGroupRequest): Observable<FileGroup> {
    return this.http.put<{ message: string; file_group: FileGroup }>(`${this.baseUrl}${interactionId}/file-groups/${groupId}`, data)
      .pipe(map(response => response.file_group));
  }

  updateArchives(interactionId: number | string, groupId: string, archiveIds: (string | number)[]): Observable<FileGroup> {
    return this.http.put<{ message: string; file_group: FileGroup }>(`${this.baseUrl}${interactionId}/file-groups/${groupId}/archives`, { archive_ids: archiveIds })
      .pipe(map(response => response.file_group));
  }

  delete(interactionId: number | string, groupId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}${interactionId}/file-groups/${groupId}`);
  }
}
